import React from "react";
import { GET } from "lib/api";
import InputLabelDatePicker from "Components/Fragment/InputLabelDatePicker";
import Form from "lib/components/Form";
import { Label } from "lib/components/Form";
import { IconButton } from "lib/components/Button";
import PersonalGoalsDropdown from "lib/components/PersonalGoalsDropdown";
import { openExternalURL } from "lib/utils";
import PriorityDropdown from "lib/components/PriorityDropdown";
import { Grid } from "Components/Base/Layout/Grid";
import { Box } from "Components/Base/Layout/Box";
import { Button } from "Components/Base/Inputs/Button";
import LuvitComponent from "LuvitComponent";
import Dropzone from "react-dropzone";
import { autobind } from "lib/decorators";
import ValidationSummary from "lib/components/ValidationSummary";
import _ from "lodash";
import SettingStore from "stores/settings";
import * as constants from "./constants";
import * as styles from "./styles";
import { Input } from "Components/Base/Inputs/Input";

const ACTIVITY_CATEGORIES_API = "v1/activitycategories";

export default class AddOtherActivity extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "TalentManagement");

    this.state = {
      activityCategories: [],
      expireDate: null,
      startDate: null,
      endDate: null,
      errorMsgs: [],
      errorElements: [],
    };

    this.clearForm = this.clearForm.bind(this);
    this.fetchActivityCategories = this.fetchActivityCategories.bind(this);
    this.doRenderActivityCategories =
      this.doRenderActivityCategories.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.fetchActivityCategories();
  }

  async componentWillMount() {
    const { activity } = this.props;
    const isBt = SettingStore.getSettingValue("bt") === "1";

    const allowedExtensions = await GET("/v1/allowedextensions");
    let expireDate =
      activity && (activity.dueDate || activity.deadlineDate || "");
    if (expireDate.length > 10) expireDate = expireDate.split("T")[0];
    const startDate = activity && (activity.startDate || "");
    const endDate = activity && (activity.endDate || "");
    const personalGoalId =
      activity && (activity.personalGoalId || activity.goalId);
    this.setState({
      title: activity.title,
      ready: true,
      editDoc: {},
      allowedExtensions,
      expireDate,
      startDate,
      endDate,
      isBt: isBt || false,
      personalGoalId,
    });
  }

  componentWillReceiveProps(props) {
    let errors = {};
    if (props.error) {
      errors.file = { msg: this.l(props.error) };
    }

    this.setState({ errors });
  }

  SaveActivity() {
    const {
      fromEducationHistory,
      activity,
      isProgramCommonActivity,
      personalId,
    } = this.props;

    const {
      files,
      title,
      startDate,
      endDate,
      removeAttachment,
      expireDate,
      personalGoalId,
      errorElements,
      activityCategories,
    } = this.state;

    let errorMsgs = [];
    let tempErrorElements = errorElements.slice(0);
    const saveActivityCategory = activityCategories.length > 0;

    if (!title) {
      errorMsgs.push({ msg: this.l("errEnterTitle") });

      if (!tempErrorElements.includes("title")) {
        tempErrorElements.push("title");
      } else {
        tempErrorElements.forEach((e, i) => {
          if (e === "title") {
            tempErrorElements.splice(i, 1);
          }
        });
      }
    }

    if (!fromEducationHistory && !this.state.expireDate) {
      errorMsgs.push({ msg: this.l("enterExpiredate") });

      if (!tempErrorElements.includes("expiredate")) {
        tempErrorElements.push("expiredate");
      } else {
        tempErrorElements.forEach((e, i) => {
          if (e === "expiredate") {
            tempErrorElements.splice(i, 1);
          }
        });
      }
    }

    if (files) {
      if (!this.extOk(files[0].name)) {
        errorMsgs.push({ msg: this.l("extnotallowed") });
      }
    }

    if (errorMsgs.length === 0) {
      let data;
      let activityTitle = "";
      let description = "";
      let responsible = "";
      let link = activity.link ?? "";
      let linkLabel = activity.linkLabel ?? "";

      if (isProgramCommonActivity) {
        activityTitle = activity.title;
        description = activity.description;
      } else {
        activityTitle = title;
        description = this.refs.TxtDescription.value;
      }

      if (this.refs.TxtResponsible) {
        responsible = this.refs.TxtResponsible.value;
      }
      if (this.refs.TxtLink) {
        link = this.refs.TxtLink.value;
      }

      if (this.refs.TxtLinkLabel) {
        linkLabel = this.refs.TxtLinkLabel.value;
      }

      if (fromEducationHistory) {
        data = {
          personalId,
          attachmentId: activity.attachmentId,
          title: activityTitle,
          comments: this.refs.TxtComment.value || "-",
          isCompleted: true,
          createdBy: personalId,
          description,
          startDate: startDate == "" ? null : startDate,
          endDate: endDate == "" ? null : endDate,
          isOtherTraining: true,
          removeAttachment,
          isExternalCourse: false,
        };
      } else {
        data = {
          personalId,
          attachmentId: activity.attachmentId,
          compTalkId: null,
          courseObjectId: null,
          title: activityTitle,
          comments: this.refs.TxtComment.value || "-",
          isCompleted: this.refs.ChkCompleted.checked,
          createdBy: personalId,
          period: "-",
          priority: this.refs.SelPrio
            ? this.refs.SelPrio.state.currentValue
            : null,
          description,
          showComment: false,
          startDate: startDate == "" ? null : startDate,
          endDate: endDate == "" ? null : endDate,
          isOtherTraining: true,
          courseId: null,
          deadlineDate: expireDate,
          personalGoalId,
          responsible,
          link,
          linkLabel,
          removeAttachment,
          allowUserToCompleteActivity:
            this.getAllowUserToCompleteActivityFormValue(),
          isExternalCourse: false,
        };
      }

      if (saveActivityCategory) {
        let category = "";

        if (this.refs.activityCategory) {
          category = this.refs.activityCategory.value;
        }

        data.category = category;
      }
      this.props.save(data, files);
    } else {
      document.getElementsByClassName("movablemodal-body")[0].scrollTop = 0;
    }

    this.setState({ errorMsgs, errorElements: tempErrorElements });
  }

  async fetchActivityCategories() {
    const categories = await GET(`${ACTIVITY_CATEGORIES_API}`);
    this.setState({ activityCategories: categories });
  }

  extOk(fileName) {
    let extPos = fileName.lastIndexOf(".");
    let ext = fileName.substr(extPos + 1);
    let foundExt = _.find(this.state.allowedExtensions, (e) => {
      return e == ext.toLowerCase();
    });
    return foundExt;
  }

  @autobind
  onDrop(files) {
    const { editDoc } = this.state;

    this.setState({ files, removeAttachment: false });

    if (editDoc.attachmentId) {
      editDoc.fileName = files[0].name;
      this.setState({ editDoc: editDoc });
    }
  }

  getAllowUserToCompleteActivityFormValue() {
    const { isManager, activity } = this.props;
    const isNewActivity = !activity.id;

    if (isManager && this.refs.ChkAllowUserToCompleteActivity.checked) {
      return true;
    }
    if (!isManager) {
      if (isNewActivity || activity.allowUserToCompleteActivity) {
        return true;
      }
    }
    return false;
  }

  renderSelectedFiles() {
    const { activity } = this.props;
    const { files, removeAttachment } = this.state;

    let selectedFiles = <div />;

    if (files) {
      selectedFiles = files.map((f) => {
        return (
          <div key={f.name} className="dropzone-selectedfiles-file">
            {f.name}
          </div>
        );
      });
    } else if (activity.attachmentId && !removeAttachment) {
      selectedFiles = (
        <div key={activity.fileName} className="dropzone-selectedfiles-file">
          <a
            href={
              "utils/StreamFile.aspx?type=goalactivity&param=" +
              activity.id +
              "&attachmentid=" +
              activity.attachmentId
            }
            className="nowrap"
            target="_blank"
            rel="noreferrer noopener"
          >
            {activity.fileName}
          </a>
          &nbsp;
          <span
            className="fa fa-external-link"
            aria-hidden="true"
            title={this.l("openinnewwindow")}
          />
        </div>
      );
    }
    return selectedFiles;
  }

  renderCommonActivityFiles() {
    const { activity } = this.props;
    const { files, removeAttachment } = this.state;

    let selectedFiles = <div />;

    if (activity.commonActivityAttachmentID && !removeAttachment) {
      selectedFiles = (
        <div
          key={activity.commonActivityFileName}
          className="dropzone-selectedfiles-file"
        >
          <a
            href={
              "utils/StreamFile.aspx?type=commonActivity&param=" +
              activity.commonActivityID +
              "&param2=" +
              activity.personalPlannedCoursesID +
              "&attachmentid=" +
              activity.commonActivityAttachmentID
            }
            className="nowrap"
            target="_blank"
            rel="noreferrer noopener"
          >
            {activity.commonActivityFileName}
          </a>
          &nbsp;
          <span
            className="fa fa-external-link"
            aria-hidden="true"
            title={this.l("openinnewwindow")}
          />
        </div>
      );
    }
    return selectedFiles;
  }

  clearForm() {
    this.title.value = "";
    this.refs.TxtDescription.value = "";
    this.refs.TxtComment.value = "";
    this.refs.TxtResponsible.value = "";
    this.refs.SelPrio.value = "-";
  }

  saveExpireDate(date) {
    this.setState({ expireDate: date });
  }

  saveStartDate(date) {
    this.setState({ startDate: date });
  }

  saveEndDate(date) {
    this.setState({ endDate: date });
  }

  removeFile() {
    if (confirm(this.l("confirmdeletefile"))) {
      this.setState({ removeAttachment: true, files: null });
    }
  }

  doRenderActivityCategories(categories, activity) {
    return (
      <div>
        <label htmlFor="addactivityCategory" className="aligntop">
          {this.l("category")}:
        </label>
        <select
          name="addactivityCategory"
          id="addactivityCategory"
          className="flex-1"
          ref="activityCategory"
          aria-label={this.l("category")}
          defaultValue={activity.activityCategoryId}
        >
          <option value="0">- {this.l("choosecategory")} - </option>
          {categories.map((category, index) => (
            <option value={category.activityCategoryId} key={index}>
              {this.l(category.title)}
            </option>
          ))}
        </select>
      </div>
    );
  }

  doRender() {
    const {
      isProgramCommonActivity,
      fromProgramPage,
      personalName,
      activity,
      fromEducationHistory,
      isManager,
      personalId,
      allowAttachment,
      onCancel,
    } = this.props;

    const {
      ready,
      activityCategories,
      errorMsgs,
      isBt,
      expireDate,
      startDate,
      endDate,
      errors,
      removeAttachment,
    } = this.state;
    let { editDoc, files } = this.state;

    if (!this.state || !ready) return <div />;
    let act = activity;
    const newActivity = !act.hasOwnProperty("id");
    const HideCompletedCheckbox =
      fromEducationHistory ||
      (!act.allowUserToCompleteActivity && !isManager) ||
      newActivity;

    let responsible = personalName;
    let renderActivityCategories = activityCategories.length > 0 || false;

    if (act && act.id) responsible = "";

    const programMyLearningViewShowLink = !isBt && act.link;

    return (
      <Form onSubmit={() => this.SaveActivity()}>
        <div id="addactivity" role="group" aria-labelledby="dialog-title">
          {errorMsgs.length > 0 && <ValidationSummary errors={errorMsgs} />}
          <div className="input-box">
            <Label
              htmlFor="inputAddactivity-title"
              className="required"
              label={this.l("title") + ":"}
            />
            {isProgramCommonActivity ? (
              <p id="inputAddactivity-title">{act.title}</p>
            ) : (
              <Input
                id="inputAddactivity-title"
                placeholder=" "
                defaultValue={act.title}
                onChange={(e) => this.setState({ title: e.target.value })}
                required
                error={this.state.errorElements.includes("title")}
              />
            )}
          </div>
          {renderActivityCategories &&
            !fromProgramPage &&
            !isBt &&
            this.doRenderActivityCategories(activityCategories, act)}
          <div>
            <label htmlFor="addactivity-description" className="aligntop">
              {this.l("description")}:
            </label>
            {isProgramCommonActivity ? (
              <p id="addactivity-description" name="addactivity-description">
                {act.description}
              </p>
            ) : (
              <textarea
                id="addactivity-description"
                ref="TxtDescription"
                className="small"
                defaultValue={act.description}
              />
            )}
            {activity.commonActivityAttachmentID && (
              <p>
                <label className="aligntop">{this.l("file")}</label>
                <div className="flex">
                  <div ref="selectedfiles">
                    {this.renderCommonActivityFiles()}
                  </div>
                </div>
              </p>
            )}
          </div>
          {!fromEducationHistory && !fromProgramPage && !isBt && (
            <div>
              <label htmlFor="addactivity-priority">
                {this.l("priority") + ":"}
              </label>
              <PriorityDropdown
                id="addactivity-priority"
                defaultValue={act.priority}
                ref="SelPrio"
              />
            </div>
          )}

          {!fromProgramPage && (
            <Box display="flex" sx={{ gap: "16px", flexWrap: "wrap" }}>
              <InputLabelDatePicker
                id="CalStartDate"
                label={this.l("startdate")}
                name={this.l("startdate")}
                value={startDate || ""}
                onChange={(event) => {
                  this.saveStartDate(event.target.value);
                }}
                oldStyleLabel={true}
              />

              <InputLabelDatePicker
                id="CalEndDate"
                label={this.l("enddate")}
                name={this.l("enddate")}
                value={endDate || ""}
                onChange={(event) => {
                  this.saveEndDate(event.target.value);
                }}
                oldStyleLabel={true}
              />
            </Box>
          )}
          {!fromEducationHistory && (
            <div className="flex flex-wrap column">
              <InputLabelDatePicker
                required
                id="CalDate"
                label={this.l("expiredate")}
                name={this.l("expiredate")}
                value={expireDate}
                onChange={(event) => {
                  this.saveExpireDate(event.target.value);
                }}
                oldStyleLabel={true}
              />
            </div>
          )}

          {!fromEducationHistory && act.formalCompetencies && isBt && (
            <div>
              <label>
                {isBt
                  ? this.l("subgoals") + ":"
                  : this.l("formalCompetencies") + ":"}
              </label>
              <styles.StyledFormalCompetenceList>
                {act.formalCompetencies &&
                  act.formalCompetencies
                    .split(constants.DEVELOPMENT_PLAN_FILTER_SPLIT)
                    .map((formalComptence) => <li>{formalComptence}</li>)}
              </styles.StyledFormalCompetenceList>
            </div>
          )}
          {!fromEducationHistory && !fromProgramPage && (
            <div>
              <label htmlFor="addactivity-connecttogoal">
                {isBt ? this.l("program") + ":" : this.l("connecttogoal") + ":"}
              </label>
              <PersonalGoalsDropdown
                id="addactivity-connecttogoal"
                ref="SelPersonalGoal"
                personalId={personalId}
                defaultValue={act.personalGoalId || act.goalId}
                updateParentState={(newValue) =>
                  this.setState({ personalGoalId: newValue })
                }
              />
            </div>
          )}
          {!fromEducationHistory && !isBt && (
            <div>
              <label htmlFor="addactivity-responsible">
                {this.l("responsible1") + ":"}
              </label>
              {isProgramCommonActivity ? (
                <p id="addactivity-responsible" name="addactivity-responsible">
                  {act.responsible}
                </p>
              ) : (
                <input
                  id="addactivity-responsible"
                  type="text"
                  className="input"
                  ref="TxtResponsible"
                  defaultValue={act.responsible || responsible}
                />
              )}
            </div>
          )}
          {!fromEducationHistory && act.formalCompetencies && !isBt && (
            <div>
              <label>
                {isBt
                  ? this.l("subgoals") + ":"
                  : this.l("formalCompetencies") + ":"}
              </label>
              <styles.StyledFormalCompetenceList>
                {act.formalCompetencies &&
                  act.formalCompetencies
                    .split(constants.DEVELOPMENT_PLAN_FILTER_SPLIT)
                    .map((formalComptence) => <li>{formalComptence}</li>)}
              </styles.StyledFormalCompetenceList>
            </div>
          )}
          {programMyLearningViewShowLink && (
            <div className="flex flex-wrap">
              <div>
                <label htmlFor="addactivity-link">
                  {this.l("html-editor-link") + ":"}
                </label>
                <div className="flex align-c">
                  {fromProgramPage ? (
                    <p>{act.linkLabel || act.link}</p>
                  ) : (
                    <input
                      id="addactivity-link"
                      type="text"
                      className="input"
                      ref="TxtLink"
                      defaultValue={act.link}
                    />
                  )}
                  <IconButton
                    onClick={() => {
                      isProgramCommonActivity || this.refs.TxtLink.value !== ""
                        ? openExternalURL(
                            this.refs.TxtLink
                              ? this.refs.TxtLink.value
                              : act.link,
                          )
                        : null;
                    }}
                    icon="icon-link"
                    label={this.l("openlink")}
                  />
                </div>
              </div>
              {!fromProgramPage && (
                <div>
                  <label htmlFor="activity-link-label">
                    {this.l("linkLabel") + ":"}
                  </label>
                  <input
                    id="activity-link-label"
                    type="text"
                    className="input"
                    ref="TxtLinkLabel"
                    defaultValue={act.linkLabel}
                  />
                </div>
              )}
            </div>
          )}
          {!fromEducationHistory && <div></div>}
          {allowAttachment && !isBt && (
            <div>
              <label htmlFor="dropzoneInput">
                {this.l("document") +
                  " (" +
                  this.l("maxfilesize").toLowerCase() +
                  ": " +
                  SettingStore.getSettingValue("activityAttachmentMaxSize") +
                  " MB):"}
              </label>
              <div className="flex">
                <span>{this.l("file")}: &nbsp;</span>
                <div
                  className={
                    files || activity.attachmentId
                      ? "dropzone-selectedfiles"
                      : "hidden"
                  }
                >
                  <div ref="selectedfiles">{this.renderSelectedFiles()}</div>
                </div>
                {(files || activity.attachmentId) && !removeAttachment && (
                  <span
                    className="pointer"
                    style={{ position: "relative", top: "-10px" }}
                    role="button"
                    title={this.l("delete")}
                    onClick={this.removeFile}
                  >
                    <i
                      className="iconbutton-icon icon-trash"
                      aria-hidden="true"
                      tabIndex="0"
                    />
                  </span>
                )}
              </div>

              {errors && errors.file && (
                <div className="color-error">
                  {this.l(errors.file.msg).replace(
                    "%maxfilesize%",
                    SettingStore.getSettingValue("activityAttachmentMaxSize") +
                      " MB",
                  )}
                </div>
              )}
              <Dropzone
                inputProps={{ id: "dropzoneInput" }}
                id="DropZone"
                className="dropzone"
                onDrop={this.onDrop}
                multiple={false}
              >
                <div>
                  {files || editDoc.attachmentId
                    ? this.l("dropzoneinfo2")
                    : this.l("dropzoneinfo")}
                </div>
              </Dropzone>
            </div>
          )}
          <div>
            <label htmlFor="addactivity-comment">{this.l("comment")}:</label>
            <textarea
              id="addactivity-comment"
              ref="TxtComment"
              className="small"
              defaultValue={act.comments}
            />
          </div>
          {isManager && (
            <div className="flex align-c">
              <label htmlFor="ChkAllowUserToCompleteActivity">
                {this.l("allowUserToCompleteActivity")}:
              </label>
              <input
                type="checkbox"
                id="ChkAllowUserToCompleteActivity"
                ref="ChkAllowUserToCompleteActivity"
                defaultChecked={act.allowUserToCompleteActivity}
              />
            </div>
          )}
          <div className={HideCompletedCheckbox ? "hidden" : "flex align-c"}>
            <label htmlFor="ChkCompleted">{this.l("activitycompleted")}:</label>
            <input
              type="checkbox"
              id="ChkCompleted"
              ref="ChkCompleted"
              defaultChecked={act.isCompleted}
            />
          </div>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Button
                color="secondary"
                variant="outlined"
                onClick={onCancel}
                label={this.l("cancel")}
              />
            </Grid>
            {!act.isLocked && (
              <Grid item>
                <Button type="submit" label={this.l("save")} />
              </Grid>
            )}
          </Grid>
        </div>
      </Form>
    );
  }
}

AddOtherActivity.defaultProps = {
  activity: { title: "" },
};
